import React, { Component } from "react";
import * as THREE from "three";

class PlayerWidget extends Component {
  constructor(props, context) {
    super(props, context);
    this.onMouseDown = this.onMouseDown.bind(this);
    /*if (!props.object.phi) {
      props.object.phi = props.phi; 
    }
    if (!props.object.theta) {
      props.object.theta = props.theta;
    }*/
  }

  widgetMatrix() {
    const matrix = new THREE.Matrix4();
    const position = new THREE.Vector3().setFromSpherical(
      THREE.Spherical(
        1000,
        THREE.Math.degToRad(this.props.phi),
        THREE.Math.degToRad(this.props.theta)
      )
    );
    matrix.lookAt(new THREE.Vector3(), position, new THREE.Vector3(0, 1, 0));

    let rotation = new THREE.Euler().setFromRotationMatrix(matrix, "YXZ");
    if (this.props.rotation) {
      rotation = new THREE.Euler(
        (-this.props.rotation / 180) * Math.PI,
        rotation.y,
        rotation.z,
        "YXZ"
      );
    }
    const quaternion = new THREE.Quaternion().setFromEuler(rotation);
    const scale = new THREE.Vector3(
      this.props.scale,
      this.props.scale,
      this.props.scale
    );
    matrix.compose(
      position,
      quaternion,
      scale
    );
    return matrix;
  }

  onMouseDown(event) {
    const { onMouseDown } = this.props;
    if (onMouseDown) {
      onMouseDown(event, this.props.index);
    }
  }

  newWidgetCSSMatrix() {
    const self = this;
    const fov =
      (0.5 / Math.tan(THREE.Math.degToRad(this.props.cameraFov * 0.5))) *
      this.props.windowHeight;
    const widgetMatrix = this.widgetMatrix();
    const cssWidgetMatrix = widgetMatrix.elements.map((e, index) =>
      self.epsilon(index > 3 && index < 8 ? -e : e)
    );

    const cameraMatrix = this.props.perspectiveCamera.matrixWorldInverse;
    const cssCameraMatrix = cameraMatrix.elements.map((e, index) =>
      self.epsilon(index % 4 === 1 ? -e : e)
    );

    const threeWidgetMatrix = new THREE.Matrix4();
    threeWidgetMatrix.elements = cssWidgetMatrix;

    const widgetTranslateMatrix = new THREE.Matrix4();
    // widgetTranslateMatrix.elements[12] = -50;
    // widgetTranslateMatrix.elements[13] = -50;

    const cameraFovMatrix = new THREE.Matrix4();
    cameraFovMatrix.elements[14] = this.epsilon(fov);

    const threeCameraMatrix = new THREE.Matrix4();
    threeCameraMatrix.elements = cssCameraMatrix;

    const cameraTranslateMatrix = new THREE.Matrix4();
    cameraTranslateMatrix.elements[12] = this.props.windowWidth * 0.5;
    cameraTranslateMatrix.elements[13] = this.props.windowHeight * 0.5;

    threeWidgetMatrix.premultiply(threeCameraMatrix);
    threeWidgetMatrix.premultiply(cameraTranslateMatrix);
    threeWidgetMatrix.premultiply(widgetTranslateMatrix);
    threeWidgetMatrix.premultiply(cameraFovMatrix);

    return `matrix3d(${threeWidgetMatrix.elements.join(",")})`;
  }

  epsilon(value) {
    return Math.abs(value) < 0.000001 ? 0 : value;
  }

  render() {
    const widgetTransformStyle = this.props.perspectiveCamera
      ? this.newWidgetCSSMatrix()
      : "";
    const fov = `${(0.5 /
      Math.tan(THREE.Math.degToRad(this.props.cameraFov * 0.5))) *
      this.props.windowHeight}px`;
    const divStyle = {
      display: this.props.perspectiveCamera ? "block" : "none",
      backgroundColor: "#FF0000",
      width: "0",
      height: "0",
      position: "absolute",
      WebkitTransformOrigin: "50% 50%",
      WebkitTransform: widgetTransformStyle,
      WebkitPerspective: fov,
      MozTransformOrigin: "50% 50%",
      MozTransform: widgetTransformStyle,
      MozPerspective: fov,
      OTransformOrigin: "50% 50%",
      OTransform: widgetTransformStyle,
      OPerspective: fov,
      transformOrigin: "50% 50%",
      transform: widgetTransformStyle,
      perspective: fov
    };
    return (
      <div
        className="PlayerWidget"
        style={divStyle}
        onMouseDown={this.onMouseDown}
      >
        {this.props.children}
      </div>
    );
  }
}

export default PlayerWidget;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerWidget/PlayerWidget.js